import { addDays } from 'date-fns/addDays'
import { format } from 'date-fns/format'

import type { NlSearchResponse } from './aiSearch'
import { AI_SEARCH_TRY_ASKING_CHIPS } from './aiSearchConstants'

const FORM_DATE_FORMAT = 'yyyyMMdd'

const DEFAULT_OCCUPANCY = {
  rooms: 1,
  adults: 2,
  children: 0,
}

function todayRange(referenceDate = new Date()) {
  return {
    checkIn: format(referenceDate, FORM_DATE_FORMAT),
    checkOut: format(addDays(referenceDate, 1), FORM_DATE_FORMAT),
  }
}

function cityDestination(id: string, displayLine1: string): NonNullable<NlSearchResponse['destination']> {
  return {
    type: 'CITY',
    id,
    cityId: id,
    displayLine1,
    displayLine2: '',
  }
}

/**
 * Local interpretations for the hardcoded example chips. Clicking one applies
 * this payload without calling `/nlsearch`.
 */
export const AI_SEARCH_EXAMPLE_PRESETS: Record<
  (typeof AI_SEARCH_TRY_ASKING_CHIPS)[number],
  NlSearchResponse
> = {
  'Las Vegas with Pool': {
    destination: cityDestination('3000015284', 'Las Vegas, NV'),
    occupancy: DEFAULT_OCCUPANCY,
    filters: [{ filterType: 'amenities', filterValue: 'SPOOL', filterLabel: 'Pool' }],
    routeToPenny: false,
  },
  'Miami Deals': {
    destination: cityDestination('3000003311', 'Miami, FL'),
    occupancy: DEFAULT_OCCUPANCY,
    minPrice: null,
    maxPrice: 200,
    routeToPenny: false,
  },
  'New York with Free Breakfast': {
    destination: cityDestination('3000016152', 'New York, NY'),
    occupancy: DEFAULT_OCCUPANCY,
    filters: [{ filterType: 'amenities', filterValue: 'FBRKFST', filterLabel: 'Free Breakfast' }],
    routeToPenny: false,
  },
  'Chicago 4 Star+': {
    destination: cityDestination('3000005381', 'Chicago, IL'),
    occupancy: DEFAULT_OCCUPANCY,
    filters: [{ filterType: 'hotelStarLevel', filterValue: '4', filterLabel: '4 Star+' }],
    routeToPenny: false,
  },
}

export function getExamplePreset(label: string, referenceDate = new Date()): NlSearchResponse | undefined {
  const preset = AI_SEARCH_EXAMPLE_PRESETS[label as keyof typeof AI_SEARCH_EXAMPLE_PRESETS]
  if (!preset) return undefined

  return {
    ...preset,
    ...todayRange(referenceDate),
  }
}
